import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

/**
 * Cached fetch of /api/modules once per session.
 * Returns { modules, byId, loading }.
 */
export default function useModules() {
    const [state, setState] = useState({ modules: [], byId: {}, loading: true, error: null });

    useEffect(() => {
        let alive = true;
        api.get("/modules")
            .then(({ data }) => {
                if (!alive) return;
                const byId = {};
                data.forEach((m) => {
                    byId[m.id] = m;
                });
                setState({ modules: data, byId, loading: false, error: null });
            })
            .catch((err) => {
                if (!alive) return;
                // eslint-disable-next-line no-console
                console.error("[useModules] Failed to fetch /api/modules", err);
                setState({ modules: [], byId: {}, loading: false, error: err });
            });
        return () => {
            alive = false;
        };
    }, []);

    return state;
}
